/** Описывает состояния выполнения запроса. */
export enum RequestStatus {
    Idle = 'idle',
    Loading = 'loading',
    Success = 'success',
    Error = 'error',
}
